module.exports = __webpack_public_path__ + "media/images/spacer.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/spacer.png
// module id = 151
// module chunks = 0